import { Type } from "@typings/enums";

export type YouTubeVideoProps = {
  /** The YouTube video URL to be embedded. */
  src: string;
  /** Optional CSS class to apply to the video container. */
  className?: string;
  /** Optional title for the video, used for accessibility. */
  title?: string;
};

/**
 * YouTubeVideo component that renders an embedded YouTube video.
 */
const YouTubeVideo = ({
  src,
  className,
  title,
}: YouTubeVideoProps): React.ReactElement => {
  return (
    <div
      className={className}
      data-story-element={Type.YoutubeVideo}
      data-testid="youtube-video-component"
    >
      <iframe
        className="aspect-video w-full"
        src={src}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        title={title}
      ></iframe>
    </div>
  );
};

export default YouTubeVideo;
